import e from "@dialpad/dialtone-tokens/layered/themes/tokens-119-colors.css?inline";
//#region themes/119.js
var t = { brand: {
	css: e,
	name: "119"
} };
//#endregion
export { t as default };
